export default "__VITE_ASSET__CeRAQdhL__"